import React from 'react';
import api from 'api';
import { AlertMessage, Spinner, ListingFilters, DropdownSelector } from 'hyperdb-utils';
import ArrivalsDepartures from "../daily-rental/arrivals-departures/containers/Listing";

class Overview extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelectFilter = this.handleSelectFilter.bind(this);
    this.handleSelectFilterItem = this.handleSelectFilterItem.bind(this);
    this.refresh = this.refresh.bind(this);
  }
  componentDidMount() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser) return null;
    // For admins
    if (['admin', 'manager'].includes(currentUser.group.name)) {
      this.props.api.userSettings.getData({ url: '/default_dashboard_filter?type=json' })
        .then(setting => {
          if (setting && setting.value) {
            const params = JSON.parse(setting.value);
            const selectedFilter = params.filter;
            const selectedItemId = params.id;
            this.props.api.dashboard.setData({ selectedFilter, selectedItemId });
            this.props.api.dashboard.getOverviewData({ selectedFilter, selectedItemId });
          } else {
            this.props.api.dashboard.getOverviewData();
          }
        });
      const search = JSON.stringify([['id', 'name'], { order: { name: 'asc'}, withoutTotal: true }]);
      this.props.api.owner.getData({ url: '?search='+search })
        .then(res => res.objects.owners)
        .then(owners => this.props.api.dashboard.setData({ owners }));
      this.props.api.propertyGroup.getData({ url: '?search='+search })
        .then(res => res.objects.property_groups)
        .then(groups => this.props.api.dashboard.setData({ groups }));
    }
    // For owners
    if (currentUser.group.name === 'owner') {
      const selectedFilter = 'owner';
      const selectedItemId = currentUser.person_id;
      this.props.api.dashboard.setData({ selectedFilter, selectedItemId });
      this.props.api.dashboard.getOverviewData({ selectedFilter, selectedItemId });
    }
  }
  componentWillUnmount() {
    this.props.api.dashboard.setData({ selectedFilter: null, selectedItemId: null });
  }
  render() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser) return null;
    if (currentUser.group.name === 'cleaning_staff') {
      return <ArrivalsDepartures />
    } else {
      const { countsSentMessages, countsReceivedMessages, countsInquiries, countsReservations, totalIncome, currency } = this.props;
      const rows = [
        { label: 'Total Yesterday', attr: 'yesterday' },
        { label: 'Total Today', attr: 'today' },
        { label: 'Total Last Week', attr: 'lastWeek' },
        { label: 'Total This Week', attr: 'currentWeek' },
        { label: 'Total Last Month', attr: 'lastMonth' },
        { label: 'Total This Month', attr: 'currentMonth' },
        { label: 'Total Last Year', attr: 'lastYear' },
        { label: 'Total This Year', attr: 'currentYear' },
        { label: 'Same Day Last Year', attr: 'sameDayLastYear' },
        { label: 'Evolution from last year', attr: 'evolution' },
      ];
      return (
        <div className="content-wrapper">
          <section className="content-header content-header-fixed">
          </section>
          <section className="content content-fixed">
            {
              ['admin', 'manager'].includes(currentUser.group.name)
                ? <div className="row form-inline">
                    <div className="col-md-2">
                      <ListingFilters
                        label="Filter"
                        labelAll="None"
                        filters={ [{ value: 'group' }, { value: 'owner' }] }
                        selectedFilter={ this.props.selectedFilter }
                        onChange={ this.handleSelectFilter }
                      />
                    </div>
                    {
                      this.props.selectedFilter && this.props.selectedFilter !== 'all'
                        ? <div className="col-md-3">
                            <DropdownSelector
                              label={ null }
                              placeholder="All"
                              options={ this.filterOptions(this.props.selectedFilter) }
                              value={ this.props.selectedItemId }
                              onChange={ this.handleSelectFilterItem }
                            />
                          </div>
                        : null
                    }
                    <div className="col-md-2">
                      <button type="button" className="btn btn-sm btn-info" title="refresh" onClick={ this.refresh }><i className="fas fa-sync-alt"/></button>
                    </div>
                  </div>
                : null
            }
            <br/>
            <div className="box box-primary" style={{minHeight: 'auto'}}>
              <Spinner show={ this.props.overview_loading } />
              <div className="table-responsive table-stats">
                <table className="table table-bordered table-striped">
                  <thead>
                    {
                      ['admin', 'manager'].includes(currentUser.group.name)
                        ? <tr>
                            <th></th>
                            <th>Emails Sent</th>
                            <th>Emails Received</th>
                            <th>Inquiries</th>
                            <th>Reservations</th>
                            <th>Income</th>
                          </tr>
                        : <tr>
                            <th></th>
                            <th>Inquiries</th>
                            <th>Reservations</th>
                            <th>Income</th>
                          </tr>
                    }
                  </thead>
                  <tbody>
                    {
                      rows.map((row, i) => {
                        return (
                          ['admin', 'manager'].includes(currentUser.group.name)
                            ? <tr key={i}>
                                <td className="row-label">{ row.label }</td>
                                <td className="numeric-value">{ (countsSentMessages || {})[row.attr] }</td>
                                <td className="numeric-value">{ (countsReceivedMessages || {})[row.attr] }</td>
                                <td className="numeric-value">{ (countsInquiries || {})[row.attr] }</td>
                                <td className="numeric-value">{ (countsReservations || {})[row.attr] }</td>
                                <td className="numeric-value">{ row.attr !== 'evolution' ? ((totalIncome || {})[row.attr] || 0) + ` ${currency || ''}` : (totalIncome || {})[row.attr] }</td>
                              </tr>
                            : <tr key={i}>
                                <td className="row-label">{ row.label }</td>
                                <td className="numeric-value">{ (countsInquiries || {})[row.attr] }</td>
                                <td className="numeric-value">{ (countsReservations || {})[row.attr] }</td>
                                <td className="numeric-value">{ row.attr !== 'evolution' ? ((totalIncome || {})[row.attr] || 0) + ` ${currency || ''}` : (totalIncome || {})[row.attr] }</td>
                              </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      );
    }
  }

  refresh() {
    const selectedFilter = this.props.selectedFilter && this.props.selectedFilter !== 'all' ? this.props.selectedFilter : '';
    const selectedItemId = this.props.selectedItemId && this.props.selectedItemId !== 'all' ? this.props.selectedItemId : '';
    this.props.api.dashboard.getOverviewData({ selectedFilter, selectedItemId });
  }
  handleSelectFilter(selectedFilter) {
    this.props.api.dashboard.setData({ selectedFilter, selectedItemId: null });
  }
  handleSelectFilterItem({ value }) {
    this.props.api.dashboard.setData({ selectedItemId: value });
  }
  filterOptions(selectedFilter) {
    return (this.props[`${selectedFilter}s`] || []).map(item => ({ value: item.id, name: item.name }));
  }
};

export default api.connect(Overview, 'dashboard', { noClearOnUnmount: true });



// WEBPACK FOOTER //
// ./src/frontend/modules/dashboard/Overview.jsx